import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    placeholder: 'text-fg-muted',
    input: 'cursor-pointer',
  },
  styles: {
    placeholder: {},
    input: {},
  },
}));
